import { styled } from "@acko-tech/building-blocks.ui.common";
import { Text } from "@acko-tech/building-blocks.ui.typography";
import { resolvePath } from "@utils/resolvePath";

export const PlansTopBannerWrapper = styled.div`
    height: fit-content;
    gap: 20px;
    opacity: 1;
    border-width: 2px;
    border-top-left-radius: 24px;
    border-top-right-radius: 24px;
    padding-right: 16px;
    padding-bottom: 40px;
    padding-left: 16px;
    margin-rigth: 20px;
    // margin-left: 20px;
    background-image: ${props => props.backgroundImage ? `url(${resolvePath("/images/Desert.png")}), ${props.backgroundImage}` : `url(${resolvePath("/images/Desert.png")}), linear-gradient(113.56deg, #FFFFFF 18.91%, #E3D5FE 125.24%)`};
    background-repeat: no-repeat;
    background-position: center;
    background-size: cover;
`;

export const PlansTopBannerNudge = styled(Text)<{ isVariant1?: boolean; isVariant2?: boolean; isVariant3?: boolean }>`
    opacity: 1;
    border-bottom-right-radius: 8px;
    border-bottom-left-radius: 8px;
    padding-top: 4px;
    padding-right: 16px;
    padding-bottom: 4px;
    padding-left: 16px;
    background: ${props => 
        props.isVariant1 ? 'linear-gradient(198deg, #6952FF -30.09%, #D375E5 180.76%)' : 
        props.isVariant2 ? 'var(--Purple-P50, #EFE9FB)' : 
        props.isVariant3 ? '#E2E4FF' : 
        '#EFE9FB'};
    display: ${props => (props.isVariant1 || props.isVariant2 || props.isVariant3) ? 'inline-flex' : 'block'};
    justify-content: ${props => (props.isVariant1 || props.isVariant2 || props.isVariant3) ? 'center' : 'flex-start'};
    align-items: ${props => (props.isVariant1 || props.isVariant2 || props.isVariant3) ? 'center' : 'flex-start'};
    font-family: 'Euclid Circular B', 'Inter', sans-serif;
    font-weight: ${props => props.isVariant1 ? '600' : '500'};
    font-style: Medium;
    font-size: ${props => (props.isVariant1 || props.isVariant2 || props.isVariant3) ? '12px' : '15px'};
    leading-trim: NONE;
    line-height: 14px;
    letter-spacing: 0px;
    width: fit-content;
    margin-bottom: 32px;
    color: ${props => 
        props.isVariant1 ? '#FFF' : 
        props.isVariant3 ? 'var(--Blue-B400, #104EA3)' : 
        'var(--Purple-P400, #5920C5)'};
`;

export const PlansTopBannerHeading = styled(Text)`
    font-family: 'Euclid Circular B', 'Inter', sans-serif;
    font-weight: 600;
    font-style: Semibold;
    font-size: 20px;
    leading-trim: NONE;
    line-height: 28px;
    letter-spacing: -0.1px;
    vertical-align: middle;
    color: ${props => props.theme ==="dark" ? "var(--Neutral-N0, #FFF)" : 'var(--text-primary-n-600, #040222)'};
`;

export const PlansTopBannerSubHeading = styled(Text)`
    font-family: 'Euclid Circular B', 'Inter', sans-serif;
    font-weight: 400;
    font-style: Regular;
    font-size: 12px;
    leading-trim: NONE;
    line-height: 18px;
    letter-spacing: 0%;
    color: ${props => props.theme === "dark" ? "var(--Neutral-N0, #FFF)" : 'var(--Text-Secondary-grey400, #4B4B4B);'};
    @media (min-width: 768px) {
      font-size: 14px;
    }
    
`;

export const Price = styled(Text)`
    font-family: 'Euclid Circular B', 'Inter', sans-serif;
    font-weight: 600;
    font-style: Semibold;
    font-size: 20px;
    leading-trim: NONE;
    line-height: 28px;
    letter-spacing: -0.1px;
    margin-right: 8px;
    color: ${props => props.theme === "dark" ? "var(--Neutral-N0, #FFF)" : 'var(--text-primary-n-600, #040222)'};
`;

export const GSTCut = styled(Text)`
    font-family: 'Euclid Circular B', 'Inter', sans-serif;
    font-weight: 400;
    font-style: Regular;
    font-size: 10px;
    leading-trim: NONE;
    line-height: 14px;
    letter-spacing: 0%;
    color: ${props => props.theme === "dark" ? "var(--Neutral-N0, #FFF)" : '#5B5675'};
`;

export const SelectPlanButton = styled.button`
    opacity: 1;
    border-radius: 8px;
    padding-top: 8px;
    padding-right: 16px;
    padding-bottom: 8px;
    padding-left: 16px;
    background: #FFFFFF;
    border: none;
    cursor: pointer;

`;

export const StrikeThroughPrice = styled(Text)`
    font-family: 'Euclid Circular B', 'Inter', sans-serif;
    font-weight: 400;
    font-style: Medium;
    font-size: 14px;
    leading-trim: NONE;
    line-height: 28px;
    letter-spacing: 0px;
    text-decoration: line-through;
    color: var(--Text-Secondary-grey400, #4B4B4B);
`;
